import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-59841220"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "guide-images"
};
const _hoisted_2 = {
  class: "img-box"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "img-overlay"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = ["href", "onClick"];
import { computed } from 'vue';
import { useRouter } from 'vue-router';
export default {
  props: {
    content: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: '100%'
    },
    link: {
      type: String,
      default: ''
    },
    links: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const imageWidth = computed(() => {
      if (props.width === '100%') {
        return 'calc(100% + 60px)';
      }
      return props.width;
    });
    function isExternal(url) {
      return /^https?:\/\//i.test(url);
    }
    function handleClick(url) {
      if (!url) return;
      if (isExternal(url)) {
        window.open(url, '_blank');
      } else {
        router.push(url);
      }
    }

    // 根据数量分两行均匀分布，并尽量贴近两侧：
    // 上行数量 topCount = Math.ceil(n / 2)，下行数量 bottomCount = n - topCount
    // 行内 left 在可用宽度内线性均分（可用宽度 = 100% - 区块自身宽度），上下行 top 分别为 35% / 70%
    function getGridStyle(idx, n) {
      const overlayWidthPercent = 18;
      const topCount = Math.ceil(n / 2);
      const isTop = idx < topCount;
      const indexInRow = isTop ? idx : idx - topCount;
      const countInRow = isTop ? topCount : n - topCount;
      let leftPercent;
      if (countInRow <= 1) {
        leftPercent = 50;
      } else {
        const usable = 100 - overlayWidthPercent; // 100% 去掉左右各半块宽度
        const step = usable / (countInRow - 1);
        leftPercent = overlayWidthPercent / 2 + step * indexInRow;
      }
      const topPercent = isTop ? 35 : 70;
      return {
        top: `${topPercent}%`,
        left: `${leftPercent}%`,
        width: `${overlayWidthPercent}%`,
        height: '42px',
        transform: 'translate(-50%, -50%)'
      };
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content, (src, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: "img-wrap"
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
          class: "img",
          src: src,
          alt: "",
          style: _normalizeStyle({
            width: _unref(imageWidth)
          })
        }, null, 12, _hoisted_3), _createElementVNode("div", _hoisted_4, [__props.link ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "img-link",
          href: __props.link,
          target: "_blank",
          rel: "noopener",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleClick(__props.link), ["prevent"]))
        }, null, 8, _hoisted_5)) : _createCommentVNode("", true), __props.links && __props.links.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(__props.links, (lk, idx) => {
          return _openBlock(), _createElementBlock("a", {
            key: idx,
            class: "img-grid-link",
            style: _normalizeStyle(getGridStyle(idx, __props.links.length)),
            href: lk,
            target: "_blank",
            rel: "noopener",
            onClick: _withModifiers($event => handleClick(lk), ["prevent"])
          }, null, 12, _hoisted_6);
        }), 128)) : _createCommentVNode("", true)])])]);
      }), 128))]);
    };
  }
};